import React, { useEffect } from "react";
import { Button, Card } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "src/styles/survey-docs/index.scss";

const SurveyDocsPage: React.FC = () => {
  const navigate = useNavigate();

  // Login holatini tekshirish
  useEffect(() => {
    const isAuthenticated = localStorage.getItem("surveyAuth");
    if (!isAuthenticated) {
      navigate("/survey-login");
    }
  }, [navigate]);

  const handleGoBack = () => {
    localStorage.removeItem("surveyAuth");
    navigate("/survey-login");
  };

  const googleDocsUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLScgYhCJ3WZPBxoAnCg-aUAUu9Cyp7iNvy9U_2FA6Jl_9IybLw/viewform?embedded=true";

  return (
    <div className="survey-docs">
      <div className="survey-docs__header">
        <div className="survey-docs__title">
          <h1>Ichki audit faoliyatiga oid so'rovnoma</h1>
        </div>
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={handleGoBack}
          className="survey-docs__back-btn"
        >
          Orqaga
        </Button>
      </div>

      <Card className="survey-docs__card">
        <div className="survey-docs__iframe-container">
          <iframe
            src={googleDocsUrl}
            className="survey-docs__iframe"
            title="Ички audit faoliyatiga oid so'rovnoma"
            frameBorder="0"
            marginHeight={0}
            marginWidth={0}
          >
            Yuklanmoqda...
          </iframe>
        </div>
      </Card>
    </div>
  );
};

export default SurveyDocsPage;
